import classnames from 'classnames'
import Icon from '@components/Icon'
import Button from '@components/Button'
import Textfield from '@components/Textfield'

import styles from './styles.module.scss'

export const QuantitySelector = ({ className, value, changeQuantity, disabled }) => {
    const addQuantity = () => {
        changeQuantity(value + 1)
    }

    const subtractQuantity = () => {
        changeQuantity(value - 1)
    }

    return (
        <div
            className={classnames('d-flex', 'align-items-center', 'justify-content-end', 'mt-2', {
                [className]: !!className,
            })}>
            <div className="text-light text-small d-flex align-items-center">
                <span className="mr-2">
                    <T>subscription.purchase.label.quantity</T>
                </span>
                <Icon type="info" size="xs" />
            </div>
            <Button
                btnStyle="outline"
                onClick={subtractQuantity}
                disabled={disabled || value <= 1}
                className={classnames('ml-3', 'mr-2', styles.quantityBtn)}>
                -
            </Button>
            <Textfield
                value={value}
                onChange={e => changeQuantity(e?.target?.value)}
                name="quantity"
                type="input"
                className={styles.quantityInput}
                disabled={disabled}
            />
            <Button
                onClick={addQuantity}
                btnStyle="outline"
                className={classnames('ml-2', styles.quantityBtn)}
                disabled={disabled}>
                +
            </Button>
        </div>
    )
}

QuantitySelector.propTypes = {
    className: PropTypes.string,
    value: PropTypes.number,
    changeQuantity: PropTypes.func.isRequired,
    disabled: PropTypes.boolean,
}
